module.exports = __webpack_public_path__ + "img/banner_charge_coin.9b13ba0c.png";